import { useQuery } from '@tanstack/react-query';

const WP_API_BASE = 'https://greenmark.com.sg/blog/wp-json/wp/v2';

// Smart image extractor that finds images in content if featured image is missing
const extractSmartThumbnail = (item) => {
  // 1. Check for official featured media
  const featured = item._embedded?.['wp:featuredmedia']?.[0]?.source_url;
  if (featured) return featured;

  // 2. Scan content for the first image tag
  const imgMatch = item.content?.rendered?.match(/<img [^>]*src="([^"]+)"/);
  if (imgMatch) return imgMatch[1];

  // 3. Fallback to GreenMark placeholder
  return 'https://lh3.googleusercontent.com/aida-public/AB6AXuAWfItohFzL9vPPk7ddczFE_1KPAZh68KrWGpilDPWXpQyArzxnujWLO6pu1VHo7IuzezR5MRk0NbkBe1xQoVuqyNCZc9hObpiduYcUtnNW4cYUcXES6K9eS6HKzOmuo0eK9RGLDUPfD7YSxU2RaZUj3ur6C930t28s_WK8mFFw_aZ5DHZYwti96BJxWJEUiAwCu3msdeYhmJwrD0Ww2XzfqDHDdo1G_FLVFlyuDaVAy_LYJT2R2JBUxi5JOHDeDGJCd0yfTnfyS2w';
};

/**
 * Hook to fetch and manage WordPress pages
 */
export const usePages = () => {
  return useQuery({
    queryKey: ['wp-pages'],
    queryFn: async () => {
      const response = await fetch(`${WP_API_BASE}/pages?_embed`);
      if (!response.ok) throw new Error('Network error connecting to pages');
      const data = await response.json();
      return data.map(page => ({
        ...page,
        smartThumbnail: extractSmartThumbnail(page)
      }));
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 mins
  });
};

/**
 * Hook to fetch specifically blog posts
 */
export const usePosts = () => {
  return useQuery({
    queryKey: ['wp-posts'],
    queryFn: async () => {
      const response = await fetch(`${WP_API_BASE}/posts?_embed`);
      if (!response.ok) throw new Error('Network error connecting to posts');
      const data = await response.json();
      return data.map(post => ({
        ...post,
        smartThumbnail: extractSmartThumbnail(post)
      }));
    },
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * Hook to fetch blog categories (for the Focus section)
 */
export const useCategories = () => {
  return useQuery({
    queryKey: ['wp-categories'],
    queryFn: async () => {
      const response = await fetch(`${WP_API_BASE}/categories`);
      if (!response.ok) throw new Error('Network error connecting to categories');
      return await response.json();
    },
    staleTime: 1000 * 60 * 60, // Categories change slowly, 1hr cache
  });
};
